/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable import/first */
// Entry point for the feed.web.js bundle, this is the first JS from our app that runs
import React from 'react';
import {
    getLocaleOverride,
    setupAsync,
    getParentLocale,
} from '@eventbrite/i18n';
import { loadableReady } from '@loadable/component';
import { hydrate } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eventbrite/site-analytics';
import { initializeErrorReportingAuth } from './errorTracking';
import { initializeStatsigSdk } from './common/utils/statsig';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};
const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

const main = async () => {
    initializeErrorReportingAuth();
    try {
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations:
                    /* webpackChunkName: "authentication-i18n-translation" */ import(
                        `./i18n/translations/${parentLocale}.json`
                    ),
            });
        }
        await initializeStatsigSdk(props);
    } finally {
        // render app with server props to the DOM
        loadableReady(() => {
            hydrate(<App {...props} />, document.getElementById('root'));
        });
    }
};
main();

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
